const TOKEN_KEY = 'motusi_bearer_token';

export const tokenStorage = {
  write: (value) => sessionStorage.setItem(TOKEN_KEY, value),
  read: () => sessionStorage.getItem(TOKEN_KEY) || '',
  remove: () => sessionStorage.removeItem(TOKEN_KEY),
};
